import React, { Component } from "react";
import Navigation from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import Loading from "../Loading/Loading";
import SignIn from "../SignIn/SignIn";
import { withFirebase } from "../Firebase/Firebase";
import classNames from 'classnames';

class PageWrapper extends Component {
	_createdAnonymousUser = false;
	componentWillReceiveProps(nextProps) {
		// Check if we we're logged out and if the user requires an anonymous login
		if (
			!this._createdAnonymousUser &&
			!nextProps.loading &&
			nextProps.anonymousAuth &&
			!nextProps.authUser
		) {
			this.props.methods.signInAnonymously();
			this._createdAnonymousUser = true;
		}
	}
	
	sectionClasses() {
		let type = this.props.context ? this.props.context : 'default';
		return classNames({
			'section' : true,
			['-' + type] : true
		})
	}

	render() {

		// Loading Screen
		if(this.props.loading) return <Loading />

		if(this.props.full) return (
			<div className={this.sectionClasses()}>
				<Navigation auth={this.props.authUser} />
				{this.props.admin ? 
					(this.props.authUser && this.props.authUser.isAdmin ? this.props.children : <SignIn />)
					: (this.props.anonymousAuth ? 
						(this.props.authUser ? this.props.children : <Loading />)
						: this.props.children
					)
				}
				<Footer />
			</div>
		);

		return (
			<div className="page-wrapper">
				<Navigation auth={this.props.authUser} />
				<section className={this.sectionClasses()}>
					<div className="container">
						<article className="article">
							{this.props.admin ? 
								(this.props.authUser && this.props.authUser.isAdmin ? this.props.children : <SignIn />)
								: (this.props.anonymousAuth ? 
									(this.props.authUser ? this.props.children : <Loading />)
									: this.props.children
								)
							}
						</article>
					</div>
				</section>
				<Footer />
			</div>
		);
	}
}

export default withFirebase(PageWrapper);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/PageWrapper.js